import { render, staticRenderFns } from "./EditProfileCard.vue?vue&type=template&id=c2b48064&"
import script from "./EditProfileCard.vue?vue&type=script&lang=js&"
export * from "./EditProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports